import {
  BarChart3,
  Bot,
  BrainCircuit,
  CloudCog,
  Code2,
  Dna,
  Settings2,
  ShieldCheck,
  Sparkles,
  type LucideIcon,
} from "lucide-react";

export interface NavCourseItem {
  label: string;
  href: string;
  badge?: string;
}

export interface NavCategory {
  title: string;
  icon: LucideIcon;
  courses: NavCourseItem[];
}

export interface FeaturedCourse {
  label: string;
  description: string;
  cta: string;
  href: string;
}

export interface NavLink {
  label: string;
  href: string;
  megaMenu?: boolean;
  categories?: NavCategory[];
  featuredCourse?: FeaturedCourse;
}

export interface NavData {
  logo: {
    text: string;
    href: string;
  };
  mainLinks: NavLink[];
  cta: {
    label: string;
    href: string;
  };
}

export const navData: NavData = {
  logo: { text: "Seasoft Classes", href: "/" },

  mainLinks: [
    { label: "Home", href: "/" },
    {
      label: "Courses",
      href: "/courses",
      megaMenu: true,
      categories: [
        {
          title: "AI Courses",
          icon: BrainCircuit,
          courses: [
            { label: "Artificial Intelligence Engineer", href: "/courses/artificial-intelligence-engineer", badge: "" },
            { label: "Prompt Engineering", href: "/courses/prompt-engineering", badge: "" },
            { label: "Blue Prism", href: "/courses/blue-prism", badge: "" },
            { label: "ChatGPT and Al Business Fundamentals ", href: "/courses/chatgpt-and-al-business-fundamentals", badge: "" },
            { label: "Claude and Automation", href: "/courses/claude-and-automation", badge: "" },
          ],
        },
        {
          title: "Data & Business Intelligence",
          icon: BarChart3,
          courses: [
            { label: "Data Warehousing", href: "/courses/data-warehousing", badge: "Popular" },
            { label: "MicroStrategy", href: "/courses/microstrategy" },
            { label: "Business Objects (SAP BO)", href: "/courses/business-objects" },
            { label: "Power BI", href: "/courses/power-bi", badge: "Hot" },
            { label: "Tableau", href: "/courses/tableau", badge: "New" },
          ],
        },
        {
          title: "Healthcare & Analytics",
          icon: Dna,
          courses: [
            { label: "SAS — Statistical Analysis", href: "/courses/sas-statistical-analysis", badge: "Popular" },
            { label: "Drug Safety Associate", href: "/courses/drug-safety-associate" },
            { label: "Clinical Data Management", href: "/courses/clinical-data-management", badge: "New" },
            { label: "Pharmacovigilance", href: "/courses/pharmacovigilance", badge: "New" },
          ],
        },
        {
          title: "Programming & Development",
          icon: Code2,
          courses: [
            { label: "Java", href: "/courses/java" },
            { label: "Python", href: "/courses/python", badge: "Hot" },
            { label: "Selenium (Test Automation)", href: "/courses/selenium" },
            { label: "Full Stack Development", href: "/courses/full-stack-development", badge: "New" },
          ],
        },
        {
          title: "Cloud, ERP & CRM",
          icon: CloudCog,
          courses: [
            { label: "Salesforce Administrator", href: "/courses/salesforce-administrator", badge: "Hot" },
            { label: "Salesforce Developer", href: "/courses/salesforce-developer" },
            { label: "NetSuite Functional", href: "/courses/netsuite-functional" },
            { label: "SAP FICO", href: "/courses/sap-fico", badge: "New" },
            { label: "ServiceNow", href: "/courses/servicenow", badge: "New" },
          ],
        },
        {
          title: "IT Infrastructure & Management",
          icon: ShieldCheck,
          courses: [
            { label: "CCNA", href: "/courses/ccna" },
            { label: "Linux Administration", href: "/courses/linux-administration" },
            { label: "Cybersecurity", href: "/courses/cybersecurity", badge: "Hot" },
            { label: "QA Testing", href: "/courses/qa-testing" },
            { label: "PMP", href: "/courses/pmp" },
            { label: "Agile Scrum Master", href: "/courses/agile-scrum-master" },
          ],
        },
        {
          title: "AI & Machine Learning",
          icon: Bot,
          courses: [
            { label: "Machine Learning Engineer", href: "/courses/machine-learning-engineer", badge: "" },
            { label: "Machine Learning Scientist", href: "/courses/machine-learning-scientist", badge: "" },
            { label: "Deep Learning", href: "/courses/deep-learning", badge: "" },
            { label: "Deep Learning with TensorFlow", href: "/courses/deep-learning-with-tensorflow", badge: "" },
            { label: "Natural Language Processing", href: "/courses/natural-language-processing", badge: "" },
          ],
        },
        {
          title: "Generative AI & Prompt Engineering",
          icon: Sparkles,
          courses: [
            { label: "ChatGPT and AI Business Fundamentals", href: "/courses/chatgpt-and-al-business-fundamentals", badge: "" },
            { label: "Claude and Automation", href: "/courses/claude-and-automation", badge: "" },
            { label: "Generative AI For Software Development", href: "/courses/generative-ai-for-software-development", badge: "" },
            { label: "Blue Prism", href: "/courses/blue-prism", badge: "" },
          ],
        },
        {
          title: "Automation & RPA",
          icon: Settings2,
          courses: [
            { label: "Robotic Process Automation (RPA)", href: "/courses/robotic-process-automation-rpa", badge: "" },
            { label: "UIPath", href: "/courses/uipath", badge: "" },
            { label: "Oracle Cloud Infrastructure (OCI)", href: "/courses/oracle-cloud-infrastructure", badge: "" },
          ],
        },
        {
          title: "Cloud & ERP Technologies",
          icon: CloudCog,
          courses: [
            { label: "Oracle Cloud ERP", href: "/courses/oracle-cloud-erp", badge: "" },
            { label: "Oracle Cloud HCM", href: "/courses/oracle-cloud-hcm", badge: "" },
            { label: "Oracle Cloud SCM", href: "/courses/oracle-cloud-scm", badge: "" },
            { label: "Oracle Cloud EPM", href: "/courses/oracle-cloud-epm", badge: "" },
            { label: "Oracle CX", href: "/courses/oracle-cx", badge: "" },
            { label: "Oracle Analytics", href: "/courses/oracle-analytics", badge: "" },
          ],
        },
      ],
      featuredCourse: {
        label: "🎯 Free Counseling Session",
        description: "Not sure which course fits your goal? Talk to an IT career advisor — free.",
        cta: "Book Now",
        href: "/contact-us",
      },
    },
    { label: "About Us", href: "/about-us" },
    { label: "Online Training", href: "/online-training" },
    { label: "Buy Now", href: "/payment-form" },
    { label: "Testimonials", href: "/testimonials" },
    { label: "Blog", href: "/blog" },
    { label: "Contact", href: "/contact-us" },
  ],

  cta: { label: "Enroll Now", href: "/courses" },
};

